import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationZH from './locales/zh/translation.json';
import { STORAGE_KEYS } from '../components/storageService';

// 尝试从 localStorage 获取语言设置
const getStoredLanguage = (): string | null => {
  try {
    const storedLang = localStorage.getItem(STORAGE_KEYS.LANGUAGE);
    return storedLang ? JSON.parse(storedLang) : null;
  } catch (e) {
    console.error('Error loading language from localStorage:', e);
    return null;
  }
};

const resources = {
  en: {
    translation: translationEN
  },
  zh: {
    translation: translationZH
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getStoredLanguage() || 'zh', // 先从 localStorage 获取，默认为中文
    fallbackLng: 'en', // 如果当前语言没有对应的翻译，则使用英文
    interpolation: {
      escapeValue: false // 不转义 HTML
    }
  });

export default i18n; 